<template>
  <w-card class="splash">
    <w-flex column align-center>
      <p class="ma2 title4">
        Сервис предназначен для размещения общественных инициатив студентов и голосования по ним. Каждый обучающийся может предложить инициативу по улучшению жизни университета.<br/>
        Каждая поданная инициатива проходит модерацию (но не цензуру) и размещается в общем списке. Все инициативы, которые набирают определенное количество подписей (указано перед списком поддержавших), обсуждаются на собраниях Студенческого Совета и доносятся до администрации.<br/>
        В данный момент сервис работает в тестовом режиме, поэтому не все функции работают, а те, что работают, могут делать это некорректно. Но мы доделаем.
      </p>
    </w-flex>
  </w-card>
</template>

<script>
export default {
  name: 'Splash'
}
</script>


<style>
.splash {
  max-width: 800px;

}
</style>
